import {Doughnut, mixins} from 'vue-chartjs'

const {reactiveProp} = mixins

export default {
    extends: Doughnut,
    mixins: [reactiveProp],
    props: ['chartData', 'options'],
    watch: {
        options: function () {
            this._data._chart.destroy();
            this.renderChart(this.chartData, this.options);
        }
    },
    mounted() {
        this.addPlugin({
            id: 'totalizer',

            beforeUpdate: chart => {
                let totals = {}
                let utmost = 0
                chart.data.datasets.forEach((dataset, datasetIndex) => {
                    if (chart.isDatasetVisible(datasetIndex)) {
                        utmost = datasetIndex
                        dataset.data.forEach((value, index) => {
                            if (value.y !== undefined)
                                value = value.y
                            totals[index] = (totals[index] || 0) + parseFloat(value)
                        })
                    }
                })

                chart.$totalizer = {
                    totals: totals,
                    utmost: utmost
                }
            }
        })

        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        // Toevoegen dat we de som kunnen weergeven bij de vandaag kolom

        this.addPlugin({
            id: 'textInMiddle',
            beforeDraw: function (chart) {
                const width = chart.width;
                const height = chart.height;
                let ctx = chart.ctx;
                ctx.restore();
                // Added 2 fixed sizes in pixels because I can't get it to work in responsive mode
                const fontSize = height < 200 ? 12 : 24;
                ctx.font = `${fontSize}px sans-serif`;
                ctx.textBaseline = "middle";

                const text = chart.config.data.datasets[0].textInTheMiddle;
                const textX = Math.round((width - ctx.measureText(text).width) / 2);
                const textY = height / 2 - (fontSize * (height < 200 ? 1.5 : 0.9));

                ctx.fillText(text, textX, textY);
                ctx.save();
            }
        })

        this.renderChart(this.chartData, this.options)
    }
}